define([
	"dojo/_base/declare",
	"csi/action/Controller",
	"csi/comm",
	"csi/wizard/ActionControllerMixin",
	"csi/xml",
	"./CopyProductForm"
], function(declare,Controller,comm,ActionControllerMixin,xml) {

	return declare([Controller, ActionControllerMixin], {
		FIELD_QUANTITY: "Quantity",

		FIELD_NAME: "Node Name",

		getFormData: function() {
			var	data = this.inherited(arguments);
			data.m_bRequireOne = true;
			return data;
		},

		onNextPage: function(/*csi.wizard.Widget*/wizard,
				 /*csi.wizard.Content*/currentPage,
				 /*csi.wizard.Content*/nextPage,
				 /*Boolean*/bFinish) {
				// summary: prepare the data and pass it into the next page

			return bFinish ? null : wizard.setFormDataToPage(nextPage, this.m_formData, (wizard.getIndexOfPage(nextPage) == 1));
		},

		toWriterRequest: function() {
			// summary: add colors parameter
			var fd = this.m_formData;

			var nodes = fd.getSelectedNodes(true);
			var qty = fd.getFieldValue(this.FIELD_QUANTITY);
			var name = fd.getFieldValue(this.FIELD_NAME);

			if (nodes.length)
				this.m_values = comm.createUrls(nodes.length * qty);

			var	call = this.inherited(arguments);
			call.addParameter("NewNodeURLs", xml.ATTR_CNLLIST, this.m_values);
			call.addParameter("Quantity", xml.ATTR_INTEGER, qty);
			call.addParameter("Name", xml.ATTR_STRING, name);
			return call;
		}
	});
});